import React from 'react';
import { cn } from '../../lib/utils';

export function RiskBadge({ level, size = 'default' }) {
  const getLevelConfig = () => {
    switch (level?.toLowerCase()) {
      case 'low':
      case 'green':
        return {
          bg: 'bg-success-light',
          text: 'text-success',
          label: 'Low'
        };
      case 'medium':
      case 'amber':
        return {
          bg: 'bg-warning-light',
          text: 'text-warning',
          label: 'Medium'
        };
      case 'high':
      case 'red':
        return {
          bg: 'bg-primary-light',
          text: 'text-primary',
          label: 'High'
        };
      default:
        return {
          bg: 'bg-muted',
          text: 'text-muted-foreground',
          label: level || 'Unknown'
        };
    }
  };

  const config = getLevelConfig();
  
  const sizeClasses = size === 'sm' 
    ? 'text-[10px] px-1.5 py-0.5' 
    : 'text-xs px-2 py-1';

  return (
    <span className={cn(
      'inline-flex items-center rounded-full font-medium',
      config.bg,
      config.text,
      sizeClasses
    )}>
      <span className={cn(
        'rounded-full mr-1.5',
        size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2',
        level?.toLowerCase() === 'low' || level?.toLowerCase() === 'green' ? 'bg-success' : '',
        level?.toLowerCase() === 'medium' || level?.toLowerCase() === 'amber' ? 'bg-warning' : '',
        level?.toLowerCase() === 'high' || level?.toLowerCase() === 'red' ? 'bg-primary' : '',
      )} />
      {config.label}
    </span>
  );
}

export function StatusDot({ status }) {
  const getColor = () => {
    switch (status?.toLowerCase()) {
      case 'active':
      case 'online':
      case 'success':
        return 'bg-success';
      case 'warning':
      case 'pending':
        return 'bg-warning';
      case 'error':
      case 'offline':
        return 'bg-destructive';
      default:
        return 'bg-muted-foreground';
    }
  };

  return (
    <span className={cn('w-2 h-2 rounded-full', getColor())} />
  );
}
